import Card from "../../components/card/Card";

const Landing = ({ shadow = false, openImageModal }) => {
  const card = {
    title: "Kontakt",
    icon: "fa-heart",
    text: "Don't be a stranger",
    elements: [
      <a href="mailto:helena@grahnstradgard.se"><i className="fa-solid fa-envelope"></i> helena@grahnstradgard.se</a>,
      <a href="https://www.facebook.com/grahnstradgard"><i className="fa-brands fa-facebook"></i> @grahnstradgard</a>,
      <a href="https://www.instagram.com/grahnstradgard/"><i className="fa-brands fa-instagram"></i> @grahnstradgard</a>,
    ],
  };

  return (
    <div>
      <div className="row">
        <Card {...card} />
      </div>
    </div>
  );
};

export default Landing;
